





















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import MenuListSkeltonLoader from '@/components/atoms/skelton/MenuListSkeltonLoader.vue';
import PortalFavoriteMenusDialog from '@/components/organisms/PortalFavoriteMenusDialog.vue';
import PortalFavoriteMenusPanel from '@/components/organisms/PortalFavoriteMenusPanel.vue';
import { BusEvent, BusEventTargets } from '@/containers/globals/BusEvent';
import { favoriteUpdationModule } from '@/store/modules/FavoriteUpdationStore';
import {
  ID,
  ProductMenu,
  ClickProductUrlEvent,
  EditActionEvent,
  EditActionBehavior,
  ChangeEvent,
  SaveEvent,
} from '@/types/type';

@Component({
  components: {
    MenuListSkeltonLoader,
    PortalFavoriteMenusPanel,
    PortalFavoriteMenusDialog,
  },
})
export default class PortalFavoriteMenus extends Vue {
  @Prop()
  private loading!: boolean;

  @Prop()
  private useFavorite!: boolean;

  @Prop()
  private menus!: ProductMenu[];

  private disableFavoriteAction(): void {
    BusEvent.$emit(BusEventTargets.CONFIRM_DIALOG_FAVORITE, true);
  }

  private updateFavoriteAction(): void {
    favoriteUpdationModule.setUp(this.menus);
    BusEvent.$emit(BusEventTargets.FORM_DIALOG_FAVORITE, true);
  }

  private get favoriteUpdationMenus(): ProductMenu[] {
    return favoriteUpdationModule.menuItems;
  }

  @Emit('change')
  private sortAction(event: EditActionEvent): ChangeEvent {
    const behavior: EditActionBehavior = {
      edit: () => {},
      top: () => favoriteUpdationModule.top(event.menu.id),
      up: () => favoriteUpdationModule.up(event.menu.id),
      down: () => favoriteUpdationModule.down(event.menu.id),
      bottom: () => favoriteUpdationModule.bottom(event.menu.id),
      remove: () => favoriteUpdationModule.remove(event.menu.id),
    };
    behavior[event.action]();
    return { change: true };
  }

  @Emit('favorite-menu-opened')
  private afterMenuOpen(event: ClickProductUrlEvent): ClickProductUrlEvent {
    return event;
  }

  @Emit('disable-favorite')
  private disableFavorite(): void {}

  @Emit('change-favorite-menus')
  private changeFavoriteManus(): ID[] {
    return favoriteUpdationModule.menuItems.map(menu => menu.id);
  }

  @Emit('change')
  private saveCloseAction(): SaveEvent {
    return { change: false };
  }
}
